/* unplugin-vue-components disabled */import { render } from "./supportUser.vue?vue&type=template&id=0468abe2&scoped=true"
import script from "./supportUser.vue?vue&type=script&lang=js"
export * from "./supportUser.vue?vue&type=script&lang=js"

import "./supportUser.vue?vue&type=style&index=0&id=0468abe2&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0468abe2"]])

export default __exports__